import { render, staticRenderFns } from "./PurchaseOrdersPrint.vue?vue&type=template&id=8b2a8434&scoped=true&"
import script from "./PurchaseOrdersPrint.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersPrint.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersPrint.vue?vue&type=style&index=0&id=8b2a8434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a8434",
  null
  
)

export default component.exports